import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { RankRow } from '../judicial/JudgeRanking';

// CRM summary: top 3 judges with most wins for the firm
export const JudgeRankingTop = () => {
  const { api } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/courts/ranking').then((r) => setD(r.data)).catch(() => {}); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d?.top?.length) return null;
  return (
    <div data-testid="crm-ranking-top" className="mb-6 rounded-2xl border border-amber-500/30 bg-amber-500/5 p-4">
      <div className="mb-3 flex items-center gap-2">
        <Trophy className="h-4 w-4 text-amber-400" />
        <p className="flex-1 text-sm font-semibold text-white">Jueces con más victorias de tu {d.scope === 'firma' ? 'notaría o estudio' : 'cartera'}</p>
        <Link to="/cortes?tab=ranking" data-testid="crm-ranking-link" className="text-xs text-amber-300 hover:underline">Ver ranking por región</Link>
      </div>
      <div className="grid gap-2 md:grid-cols-3">{d.top.map((j, i) => <RankRow key={j.judge_id} j={j} i={i} />)}</div>
    </div>
  );
};
